import axiosInstance from "./client";

const getIpAddress = async () => {
  const response = await axiosInstance.get(`/ip`);
  return response;
};

export { getIpAddress };
